import { render, staticRenderFns } from "./shortcodeAccordion.vue?vue&type=template&id=75587fb2&"
import script from "./shortcodeAccordion.vue?vue&type=script&lang=js&"
export * from "./shortcodeAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports